export default "__VITE_ASSET__DDoat2ia__"